import React from 'react';

import KoncertWiersz from '../components/koncerty/KoncertWiersz';
import KoncertyStrona from '../components/koncerty/KoncertyStrona';
import useKoncerty from '../hooks/useKoncerty';
import { pogrupujPoLatach } from '../utils/koncerty-format';

/**
 * Archiwum koncertów pogrupowane po rocznikach — od najnowszego.
 * Przy starszych koncertach znamy zwykle tylko rok, dlatego wiersz
 * potrafi pokazać sam rocznik zamiast pełnej daty.
 */
function KoncertyArchiwumPage({ pageContext }) {
  const { koncerty, wczytywanie } = useKoncerty(
    'archive',
    pageContext.koncerty
  );

  const roczniki = pogrupujPoLatach(koncerty);

  return (
    <KoncertyStrona
      tytul="Archiwum koncertów"
      opisSeo="Archiwum koncertów zespołu Potock — gdzie graliśmy w poprzednich latach."
      aktywnaZakladka="archiwum"
      wczytywanie={wczytywanie}
    >
      {roczniki.length > 0
        ? roczniki.map(rocznik => (
            <section className="koncerty-rocznik" key={rocznik.rok}>
              <h2 className="koncerty-rocznik__naglowek">{rocznik.rok}</h2>
              <ul className="koncerty-lista">
                {rocznik.koncerty.map(koncert => (
                  <KoncertWiersz
                    key={koncert.id}
                    koncert={koncert}
                    rokWNaglowku
                  />
                ))}
              </ul>
            </section>
          ))
        : !wczytywanie && (
            <p className="koncerty-pusto">Archiwum jest jeszcze puste.</p>
          )}
    </KoncertyStrona>
  );
}

export default KoncertyArchiwumPage;
